import ApiRoutes from '@lib/routes/ApiRoutes'
import { RequestMethod } from '../consts'
import internalJsonFetch from '../internalJsonFetch'

export default async function verifyGoogleFedCMToken({
  redirectPath,
  segmentAnonymousId,
  token,
}: {
  redirectPath?: string
  segmentAnonymousId?: string
  token: string
}) {
  return internalJsonFetch<{ email: string; name: string; picture: string }>({
    authenticated: false,
    body: {
      redirectPath,
      segmentAnonymousId,
      token,
    },
    requestMethod: RequestMethod.POST,
    url: ApiRoutes.v1.callbacks.google.verifyToken,
  })
}
